 var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
  var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
  var var_l_sph = ''; //Este es el valor del SPH en el ojo izquierdo
  var var_r_sph = ''; //Este es el valor del SPH en el ojo derecho
  var val_upc = '';//Este es el valor del UPC que será asignado a través del siguiente desarrollo 

  $('#right-upc input, #left-upc input').val(val_upc);
	
$('#left-graduacion').click(function() {
    var_l_sph = $('#4079205711950_option_4').val();
	console.log(var_l_sph); 
	unify_values_l();
	fetch_sku_l();
});


$('#right-graduacion').click(function() {
    var_r_sph = $('#4079205711950_option_5').val();
	console.log(var_r_sph); 
	unify_values_r();
	fetch_sku_r();
});


function unify_values_l(){
	sku_values_l = var_l_sph ;
	console.log(sku_values_l);
}

function unify_values_r(){
	sku_values_r = var_r_sph;
	console.log(sku_values_r);
}

function l_minus_upc(){val_upc = '20500000458442'; $('#left-upc input').val(val_upc);}
function l_plus_upc(){val_upc = '20500000637571'; $('#left-upc input').val(val_upc);}
function r_minus_upc(){val_upc = '20500000458442'; $('#right-upc input').val(val_upc);}
function r_plus_upc(){val_upc = '20500000637571'; $('#right-upc input').val(val_upc);}

function fetch_sku_l(){
 	switch (sku_values_l) { 
case '-0.50' : $('#left-sku input').val('577109'); l_minus_upc(); break;
case '-0.75' : $('#left-sku input').val('577116'); l_minus_upc(); break;
case '-1.00' : $('#left-sku input').val('577123'); l_minus_upc(); break;
case '-1.25' : $('#left-sku input').val('577130'); l_minus_upc(); break;
case '-1.50' : $('#left-sku input').val('577147'); l_minus_upc(); break;
case '-1.75' : $('#left-sku input').val('577154'); l_minus_upc(); break;
case '-2.00' : $('#left-sku input').val('577161'); l_minus_upc(); break;
case '-2.25' : $('#left-sku input').val('577178'); l_minus_upc(); break;
case '-2.50' : $('#left-sku input').val('577185'); l_minus_upc(); break;
case '-2.75' : $('#left-sku input').val('577192'); l_minus_upc(); break;
case '-3.00' : $('#left-sku input').val('577208'); l_minus_upc(); break;
case '-3.25' : $('#left-sku input').val('577215'); l_minus_upc(); break;
case '-3.50' : $('#left-sku input').val('577222'); l_minus_upc(); break;
case '-3.75' : $('#left-sku input').val('577239'); l_minus_upc(); break;
case '-4.00' : $('#left-sku input').val('577246'); l_minus_upc(); break;
case '-4.25' : $('#left-sku input').val('577253'); l_minus_upc(); break;
case '-4.50' : $('#left-sku input').val('577260'); l_minus_upc(); break;
case '-4.75' : $('#left-sku input').val('577277'); l_minus_upc(); break;
case '-5.00' : $('#left-sku input').val('577284'); l_minus_upc(); break;
case '-5.25' : $('#left-sku input').val('577291'); l_minus_upc(); break;
case '-5.50' : $('#left-sku input').val('577307'); l_minus_upc(); break;
case '-5.75' : $('#left-sku input').val('577314'); l_minus_upc(); break;
case '-6.00' : $('#left-sku input').val('577321'); l_minus_upc(); break;
case '-9.00' : $('#left-sku input').val('577338'); l_minus_upc(); break;
case '-8.50' : $('#left-sku input').val('577345'); l_minus_upc(); break;
case '-8.00' : $('#left-sku input').val('577352'); l_minus_upc(); break;
case '-7.50' : $('#left-sku input').val('577369'); l_minus_upc(); break;
case '-7.00' : $('#left-sku input').val('577376'); l_minus_upc(); break;
case '-6.50' : $('#left-sku input').val('577383'); l_minus_upc(); break;
case '-9.50' : $('#left-sku input').val('578991'); l_minus_upc(); break;
case '-10.00' : $('#left-sku input').val('579004'); l_minus_upc(); break;
case '-10.50' : $('#left-sku input').val('579011'); l_minus_upc(); break;
case '-11.00' : $('#left-sku input').val('579028'); l_minus_upc(); break;
case '-11.50' : $('#left-sku input').val('579035'); l_minus_upc(); break;
case '-12.00' : $('#left-sku input').val('579042'); l_minus_upc(); break;
case '+0.50' : $('#left-sku input').val('576645'); l_plus_upc(); break;
case '+0.75' : $('#left-sku input').val('576652'); l_plus_upc(); break;
case '+1.00' : $('#left-sku input').val('576669'); l_plus_upc(); break;
case '+1.25' : $('#left-sku input').val('576676'); l_plus_upc(); break;
case '+1.50' : $('#left-sku input').val('576683'); l_plus_upc(); break;
case '+1.75' : $('#left-sku input').val('576690'); l_plus_upc(); break;
case '+2.00' : $('#left-sku input').val('576706'); l_plus_upc(); break;
case '+2.25' : $('#left-sku input').val('576713'); l_plus_upc(); break;
case '+2.50' : $('#left-sku input').val('576720'); l_plus_upc(); break;
case '+2.75' : $('#left-sku input').val('576737'); l_plus_upc(); break;
case '+3.00' : $('#left-sku input').val('576744'); l_plus_upc(); break;
case '+3.25' : $('#left-sku input').val('576751'); l_plus_upc(); break;
case '+3.50' : $('#left-sku input').val('576768'); l_plus_upc(); break;
case '+3.75' : $('#left-sku input').val('576775'); l_plus_upc(); break;
case '+4.00' : $('#left-sku input').val('576782'); l_plus_upc(); break;
case '+4.25' : $('#left-sku input').val('576799'); l_plus_upc(); break;
case '+4.50' : $('#left-sku input').val('576805'); l_plus_upc(); break;
case '+4.75' : $('#left-sku input').val('576812'); l_plus_upc(); break;
case '+5.00' : $('#left-sku input').val('576829'); l_plus_upc(); break;
case '+5.25' : $('#left-sku input').val('576836'); l_plus_upc(); break;
case '+5.50' : $('#left-sku input').val('576843'); l_plus_upc(); break;
case '+5.75' : $('#left-sku input').val('576850'); l_plus_upc(); break;
case '+6.00' : $('#left-sku input').val('576867'); l_plus_upc(); break;


 	    default:
        $('#left-sku input').val('SKU Desconocido');
    }
}//fetch_sku()

function fetch_sku_r(){
 	switch (sku_values_r) {
case '-0.50' : $('#right-sku input').val('577109'); r_minus_upc(); break;
case '-0.75' : $('#right-sku input').val('577116'); r_minus_upc(); break;
case '-1.00' : $('#right-sku input').val('577123'); r_minus_upc(); break;
case '-1.25' : $('#right-sku input').val('577130'); r_minus_upc(); break;
case '-1.50' : $('#right-sku input').val('577147'); r_minus_upc(); break;
case '-1.75' : $('#right-sku input').val('577154'); r_minus_upc(); break;
case '-2.00' : $('#right-sku input').val('577161'); r_minus_upc(); break;
case '-2.25' : $('#right-sku input').val('577178'); r_minus_upc(); break;
case '-2.50' : $('#right-sku input').val('577185'); r_minus_upc(); break;
case '-2.75' : $('#right-sku input').val('577192'); r_minus_upc(); break;
case '-3.00' : $('#right-sku input').val('577208'); r_minus_upc(); break;
case '-3.25' : $('#right-sku input').val('577215'); r_minus_upc(); break;
case '-3.50' : $('#right-sku input').val('577222'); r_minus_upc(); break;
case '-3.75' : $('#right-sku input').val('577239'); r_minus_upc(); break;
case '-4.00' : $('#right-sku input').val('577246'); r_minus_upc(); break;
case '-4.25' : $('#right-sku input').val('577253'); r_minus_upc(); break;
case '-4.50' : $('#right-sku input').val('577260'); r_minus_upc(); break;
case '-4.75' : $('#right-sku input').val('577277'); r_minus_upc(); break;
case '-5.00' : $('#right-sku input').val('577284'); r_minus_upc(); break;
case '-5.25' : $('#right-sku input').val('577291'); r_minus_upc(); break;
case '-5.50' : $('#right-sku input').val('577307'); r_minus_upc(); break;
case '-5.75' : $('#right-sku input').val('577314'); r_minus_upc(); break;
case '-6.00' : $('#right-sku input').val('577321'); r_minus_upc(); break;
case '-9.00' : $('#right-sku input').val('577338'); r_minus_upc(); break;
case '-8.50' : $('#right-sku input').val('577345'); r_minus_upc(); break;
case '-8.00' : $('#right-sku input').val('577352'); r_minus_upc(); break;
case '-7.50' : $('#right-sku input').val('577369'); r_minus_upc(); break;
case '-7.00' : $('#right-sku input').val('577376'); r_minus_upc(); break;
case '-6.50' : $('#right-sku input').val('577383'); r_minus_upc(); break;
case '-9.50' : $('#right-sku input').val('578991'); r_minus_upc(); break;
case '-10.00' : $('#right-sku input').val('579004'); r_minus_upc(); break;
case '-10.50' : $('#right-sku input').val('579011'); r_minus_upc(); break;
case '-11.00' : $('#right-sku input').val('579028'); r_minus_upc(); break;
case '-11.50' : $('#right-sku input').val('579035'); r_minus_upc(); break;
case '-12.00' : $('#right-sku input').val('579042'); r_minus_upc(); break;
case '+0.50' : $('#right-sku input').val('576645'); r_plus_upc(); break;
case '+0.75' : $('#right-sku input').val('576652'); r_plus_upc(); break;
case '+1.00' : $('#right-sku input').val('576669'); r_plus_upc(); break;
case '+1.25' : $('#right-sku input').val('576676'); r_plus_upc(); break;
case '+1.50' : $('#right-sku input').val('576683'); r_plus_upc(); break;
case '+1.75' : $('#right-sku input').val('576690'); r_plus_upc(); break;
case '+2.00' : $('#right-sku input').val('576706'); r_plus_upc(); break;
case '+2.25' : $('#right-sku input').val('576713'); r_plus_upc(); break;
case '+2.50' : $('#right-sku input').val('576720'); r_plus_upc(); break;
case '+2.75' : $('#right-sku input').val('576737'); r_plus_upc(); break;
case '+3.00' : $('#right-sku input').val('576744'); r_plus_upc(); break;
case '+3.25' : $('#right-sku input').val('576751'); r_plus_upc(); break;
case '+3.50' : $('#right-sku input').val('576768'); r_plus_upc(); break;
case '+3.75' : $('#right-sku input').val('576775'); r_plus_upc(); break;
case '+4.00' : $('#right-sku input').val('576782'); r_plus_upc(); break;
case '+4.25' : $('#right-sku input').val('576799'); r_plus_upc(); break;
case '+4.50' : $('#right-sku input').val('576805'); r_plus_upc(); break;
case '+4.75' : $('#right-sku input').val('576812'); r_plus_upc(); break;
case '+5.00' : $('#right-sku input').val('576829'); r_plus_upc(); break;
case '+5.25' : $('#right-sku input').val('576836'); r_plus_upc(); break;
case '+5.50' : $('#right-sku input').val('576843'); r_plus_upc(); break;
case '+5.75' : $('#right-sku input').val('576850'); r_plus_upc(); break;
case '+6.00' : $('#right-sku input').val('576867'); r_plus_upc(); break;

 		default:
        $('#right-sku input').val('SKU Desconocido');
    }
}//fetch_sku()
